import { useCallback, useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { UserContext } from '../../context';
import { StoryStatus } from '../../services';
import { getStories } from '../../slices';
import { STORY_TAB_ADMIN_COOKIE_KEY } from '../constants';
import { StoryTabType } from '../models';
import { getStorySectionByTabType, isAdminLayout } from '../utils';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';

interface StoriesFeedArgs {
  storyTabType?: StoryTabType;
}

export const useStoriesFeed = ({ storyTabType }: StoriesFeedArgs) => {
  const dispatch = useAppDispatch();

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { query } = useAppSelector(({ stories }) => stories);

  const [cookies] = useCookies([STORY_TAB_ADMIN_COOKIE_KEY]);

  const { requestFilter = {} } = { ...cookies[STORY_TAB_ADMIN_COOKIE_KEY] };

  const filter = useMemo(() => {
    if (!isAdminLayout()) {
      return { onlyPostIn: false, status: [StoryStatus.PUBLISHED] };
    }

    if (!storyTabType) {
      return { ...requestFilter, query };
    }

    return { ...requestFilter, query, section: getStorySectionByTabType(storyTabType) };
  }, [query, requestFilter, storyTabType]);

  const getStoriesFeed = useCallback(
    () => dispatch(getStories({ channelId, filter })),
    [channelId, dispatch, filter]
  );

  return { getStoriesFeed };
};
